/*
 * Japanese search terms as phrases.
 *
 * Shopify's search splits a Japanese word into pieces and matches any of
 * them, so 旅のおと also finds every article with 旅 or の in it. A term in
 * quotes is matched as written, so each term with Japanese (non-ASCII) text
 * is quoted when a search form is sent. On the results page the quotes are
 * taken off again in the search boxes, so readers see what they typed.
 */
const QUOTED = /^".*"$/;
const NON_ASCII = /[^\x00-\x7F]/;

const quoteTerms = (value) =>
  value
    .split(/[\s　]+/)
    .filter(Boolean)
    .map((term) => (NON_ASCII.test(term) && !QUOTED.test(term) ? `"${term.replace(/"/g, '')}"` : term))
    .join(' ');

const unquoteTerms = (value) =>
  value
    .split(/\s+/)
    .filter(Boolean)
    .map((term) => (NON_ASCII.test(term) && QUOTED.test(term) ? term.slice(1, -1) : term))
    .join(' ');

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement) || !input.value) return;
    input.value = quoteTerms(input.value);
  },
  true
);

for (const input of document.querySelectorAll('input[name="q"]')) {
  if (input instanceof HTMLInputElement && input.value) input.value = unquoteTerms(input.value);
}

window.CirclesSearchTerms = { quote: quoteTerms };
